"use client";

import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LlamadoAlBienestar() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="llamado-al-bienestar" className="w-full bg-background py-40">
      <div ref={ref} className={`max-w-4xl mx-auto px-6 text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-14 tracking-tight text-balance">
          Recupera el tiempo de calidad con los tuyos
        </h2>

        <Button asChild className="bg-[#25D366] hover:bg-[#22bf5b] text-white h-auto py-6 px-8 md:px-12 rounded-2xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border-none">
          <Link to="https://wa.me/56934141843?text=Hola NexoMayor, quiero agendar una evaluación para coordinar el cuidado de un familiar." newTab className="flex items-center gap-4 md:gap-5">
            <MessageCircle className="w-8 h-8 md:w-10 md:h-10 shrink-0" strokeWidth={2.5} />
            <span className="text-xl md:text-3xl font-bold tracking-wide">
              Hablar con un Care Planner
            </span>
          </Link>
        </Button>
      </div>
    </section>;
}